import { Component, type ErrorInfo, type ReactNode } from "react";
import DataBankEmptyState from "./DataBankEmptyState";

type Props = { children: ReactNode; label: string };

type State = { hasError: boolean };

export class DataBankViewErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error(`Data bank view (${this.props.label}):`, error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <DataBankEmptyState
                    variant="error"
                    message={`Could not display ${this.props.label}. The data may be missing or in an unexpected format.`}
                />
            );
        }
        return this.props.children;
    }
}
